module.exports = __webpack_public_path__ + "static/media/transaction4.a1cf134e.png";